import React, { useEffect } from 'react';
import { CustomAutocomplete } from '../../../../../shared/components/Autocomplete';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { useTranslation } from 'react-i18next';
import CustomDatePicker from '../../../../../shared/components/DatePicker';

interface IStepThreeLongTermComponentProps {
    handleChangeTimepicker: (newValue: Date | null, name: string) => void;
    multipleSelectHandler: (paramKey: string, paramValue: any) => void;
    date?: string;
    invoicePeriod?: string;
    invoiceDuration?: string;
    isApproved?: boolean;
}

const StepThreeLongTermComponent = ({
    handleChangeTimepicker,
    invoicePeriod,
    date,
    isApproved,
    invoiceDuration,
    multipleSelectHandler,
}: IStepThreeLongTermComponentProps) => {
    const {
        InvoicePeriodEnum,
        CampaignDurationEnum,
        PaymentTermsEnum: PaymentTermsEnumArr,
    } = useSelector((states: IAllStates) => states.enums);

    const { t } = useTranslation();

    const filteredInvoicePeriods = () => {
        if (invoiceDuration === 'month_12') {
            return InvoicePeriodEnum;
        }

        return InvoicePeriodEnum?.filter(period => period !== 'quarterly');
    };

    useEffect(() => {
        if (invoiceDuration !== 'month_12' && invoicePeriod === 'quarterly') {
            multipleSelectHandler('invoicePeriod', 'monthly');
        }
    }, [invoiceDuration, invoicePeriod, multipleSelectHandler]);

    return (
        <>
            <div className="w-md-75">
                <div className="d-flex flex-column">
                    {/*APPLICATION DEADLINE*/}
                    <div className="mb-1">
                        <h6 className="font-weight-bold mb-0 ">{t('brand.campaign.briefing.step3.start_date')}</h6>
                        <span className="text-muted">{t('brand.campaign.briefing.step3.start_date_desc')}</span>
                    </div>
                    <div className="w-100 d-flex align-items-center my-2">
                        <div className="w-md-70">
                            <CustomDatePicker
                                label={t('brand.campaign.briefing.step3.start_date')}
                                value={date}
                                disabled={isApproved}
                                disableFrom={new Date()}
                                onChange={e => handleChangeTimepicker(e, 'date')}
                            />
                        </div>
                    </div>
                    {/*Campaign duration*/}
                    <div className="mb-1">
                        <h6 className="font-weight-bold mb-0 ">
                            {t('brand.campaign.briefing.step3.campaign_duration')}
                        </h6>
                        <span className="text-muted">{t('brand.campaign.briefing.step3.campaign_duration_desc')}</span>
                    </div>
                    <div className="d-flex align-items-center my-2">
                        <CustomAutocomplete
                            dataArray={CampaignDurationEnum}
                            isMultiple={false}
                            defaultArray={invoiceDuration ? [invoiceDuration] : ''}
                            isWithImage={false}
                            isRequired={true}
                            classes="w-md-70"
                            inputLabel="Campaign Duration"
                            isDisabled={isApproved}
                            disableClearable={true}
                            queryFilterKey="invoiceDuration"
                            inputLabelTranslation={t('brand.campaign.briefing.step3.campaign_duration')}
                            handleChangeParams={multipleSelectHandler}
                        />
                    </div>

                    {/*Payment method*/}
                    <div className="mb-1">
                        <h6 className="font-weight-bold mb-0 ">{t('brand.campaign.briefing.step3.payout_method')}</h6>
                        <span className="text-muted">{t('brand.campaign.briefing.step3.payout_method_desc')}</span>
                    </div>
                    <div className="d-flex align-items-center my-2">
                        <CustomAutocomplete
                            dataArray={filteredInvoicePeriods() ?? []}
                            isRequired={true}
                            isMultiple={false}
                            defaultArray={invoicePeriod ? [invoicePeriod] : ''}
                            isWithImage={false}
                            classes="w-md-70"
                            inputLabel="Payment method"
                            isDisabled={isApproved}
                            disableClearable={true}
                            queryFilterKey="invoicePeriod"
                            inputLabelTranslation={t('brand.campaign.briefing.step3.payout_method')}
                            handleChangeParams={multipleSelectHandler}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepThreeLongTermComponent;
